import { render, staticRenderFns } from "./TradeInSpecialPage.vue?vue&type=template&id=4f082db9&scoped=true&"
import script from "./TradeInSpecialPage.vue?vue&type=script&lang=js&"
export * from "./TradeInSpecialPage.vue?vue&type=script&lang=js&"
import style0 from "./TradeInSpecialPage.vue?vue&type=style&index=0&id=4f082db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f082db9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f082db9')) {
      api.createRecord('4f082db9', component.options)
    } else {
      api.reload('4f082db9', component.options)
    }
    module.hot.accept("./TradeInSpecialPage.vue?vue&type=template&id=4f082db9&scoped=true&", function () {
      api.rerender('4f082db9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TradeInSpecialPage.vue"
export default component.exports